import { globals } from '../utils';
import { getSkyfireEnvironment } from './getSkyfireEnvironment';
export async function skyfireRequest(url, headers) {
    if (url.startsWith('http://localhost:8080')) {
        url = url.replace('http://localhost:8080', getSkyfireEnvironment());
    }
    const response = await globals.fetch(url, { method: 'get', headers });
    const json = await response.json();
    return json.methods;
}
